import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import './ScrollAnimation.css';

const AnimatedSection = ({ 
  children, 
  animationType = 'slide-up', 
  threshold = 0.1, 
  rootMargin = '0px',
  className = '',
  stagger = null,
  display = 'block'
}) => {
  const [ref, isVisible] = useScrollAnimation(threshold, rootMargin);
  
  const animationClass = `${animationType}${stagger ? ` stagger-${stagger}` : ''}`;
  const combinedClassName = `${animationClass} ${className}`.trim();
  
  return (
    <div 
      ref={ref} 
      className={`${combinedClassName} ${isVisible ? 'animate' : ''}`}
      style={{ display }}
    >
      {children}
    </div>
  );
};

export default AnimatedSection; 